$(document).ready(function() {
    window.$window = $(window);

    var assets = [
        './assets/img/header_01.jpg',
        './assets/img/header_02.jpg',
        './assets/img/header_03.jpg',
        './assets/img/header_04.jpg',
    ];

    var min_load_time = 0; //ms
    var starttime = Date.now();

    function preLoad() {
        var preload = new createjs.LoadQueue();
        preload.addEventListener("fileload", function () {
            //initApp();
        });

        assets.forEach(function (url) {
            preload.loadFile(url);
        });

        var css = document.createElement('link');
        css.rel = 'stylesheet';
        css.href = './assets/css/app.bundle.css?v=1.0';
        css.type = 'text/css';
        var godefer = document.getElementsByTagName('link')[0];
        godefer.parentNode.insertBefore(css, godefer);
    }

    //preLoad();

    initApp();

    function initApp(){
        var timeleft = min_load_time - (Date.now() - starttime);

        timeleft = timeleft < 0 ? 0 : timeleft;

        console.log(timeleft);
        
        setTimeout(function () {
            $('body').removeClass('loading');
            $('#loader > *').remove();
            TweenMax.set('#loader', {opacity:1, display: 'block'});
            TweenMax.set('#app', {opacity:0});
            TweenMax.to('#loader', 0.1, {opacity:0, onComplete: function () {
                TweenMax.set('#loader', {display: 'none'});
                TweenMax.to('#app', 0.5, {opacity:1});

                initPhotoFeed();
                initButtons();
                initStickyMenu();

                $('select').select2({
                    minimumResultsForSearch: Infinity
                });


                $('select.language-switcher').change(function(e){
                    window.location = $(e.target).val();
                });


                if($('#collection').length != 0 ){
                    collection.init();
                    return;
                }

                if( $('#collection-detail--header').length != 0 ){
                    collection.initDetailPage();
                    return;
                }

                // init home
                if($('#slideContainer').length > 0){
                   var homepage = new Home();

                    homepage.animateIn();
                    homepage.setScene();

                    $( window ).resize(function() {
                        homepage.setScene();
                    });
                }


            }});


        },timeleft);
    }
});

function initButtons() {
    //  step down button

    $('#menu-button').click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('body').toggleClass('menu-open');
    });


    $('.gender-select a').click(function (e) {
        e.preventDefault();

        var gender = $(e.target).attr('href').slice( 1 );


        $('#looks article').hide();
        $('#looks article.looks--' + gender ).show();

    });



    $('#left-nav a, .smooth_scroll').click(function (e) {
        e.preventDefault();
        var target_id  = e.currentTarget.getAttribute("href");

        var scroll = parseInt( $(target_id).offset().top ) - $('#header').outerHeight();

        TweenMax.to(window, 1, {scrollTo: {y: scroll , autoKill:false}, onComplete: function () {}});
    });

    $('.collapsable-list li h3').click(function (e) {
        var target =  $(e.currentTarget).parent();
        if( target.hasClass('active') ) {
            target.removeClass('active');
        }else{
            $('.collapsable-list li').removeClass('active');
            target.addClass('active');
        }
    });
}

function initStickyMenu() {
    var $targetEl = $('#left-nav-container--content');

    if($targetEl.length == 0)
        return;

    var nav_height = $('#left-nav').outerHeight();
    var controllerSticky = new ScrollMagic.Controller();

    var duration = $targetEl.outerHeight() -  nav_height + 20;
    console.log(duration);
    
    var offsets = [];
    
    // get offsets
    var sections = $('#left-nav a');
    sections.each(function () {
        var section = $( $(this).attr('href') );

        offsets.push(section.offset().top - 150);
    });

    var $indicator = $('#left-nav .indicator');

    var offset =  $window.height()/2 - nav_height/2;

    new ScrollMagic.Scene({
        triggerElement: "#left-nav-container--content",
        offset: -offset,
        triggerHook: "onLeave",
        duration: duration
    })
        .setPin("#left-nav")
        .setClassToggle("#left-nav", "bottom") // add class toggle
        .on("progress", function (e) {
            var index;

            var scrollTop = $(window).scrollTop();

            $indicator.height('' + e.progress * 100 +'%');

            for (var i = 0; i < offsets.length; i++) {
                index = 0;
                var top = offsets[i];
                var bottom = offsets.length > i + 1 ? offsets[i+1] : 9999999999;

                if(scrollTop > top && scrollTop < bottom){
                    index = i;
                    break;
                }
            }

            $('#left-nav li').removeClass('active');
            $('#left-nav li').eq(index).addClass('active');


        })
        .addTo(controllerSticky);
}

window.isAnimating = false;

function setAnimating(bool) {
    if(window.touchMove)
        bool = false;

    window.isAnimating = bool;
    console.log(bool);

    if(bool){
        $(document).on('touchmove', function(e){e.preventDefault()});
    }else{
        $(document).off('touchmove');
    }
}

function setAnimatingxx(bool) {
    window.isAnimating = bool;

    if(bool){
        disableScroll();
    }else{
        enableScroll();
    }
}


// left: 37, up: 38, right: 39, down: 40,
// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
var keys = {
    32: 1, 33: 1, 34: 1, 35: 1, 36: 1,
    37: 1, 38: 1, 39: 1, 40: 1,
};

function preventDefault(e) {
    e = e || window.event;
    if (e.preventDefault)
        e.preventDefault();
    e.returnValue = false;
}

function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
    }
    return null;
}

function disableScroll() {
    $('body').css('touch-action', 'none');
    // $('#scroll-disabler').show();

    if (window.addEventListener) // older FF
        window.addEventListener('DOMMouseScroll', preventDefault, false);
    window.onwheel = preventDefault; // modern standard
    window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE

    window.ontouchmove = preventDefault; // mobile

    document.onkeydown  = preventDefaultForScrollKeys;
}

function enableScroll() {

    $('body').css('touch-action', 'inherit');
    // $('#scroll-disabler').hide();


    if (window.removeEventListener)
        window.removeEventListener('DOMMouseScroll', preventDefault, false);
    window.onmousewheel = document.onmousewheel = null;
    window.onwheel = null;

    document.onkeydown = null;
    window.ontouchmove = null;

    // initSmoothScroll();

    // document.body.addEventListener('touchmove', function(e){
    //     // var touchobj = e.changedTouches[0] // reference first touch point for this event
    //     // var dist = parseInt(touchobj.clientX) - startx;
    //     // handle(dist);
    //     // e.preventDefault();
    // }, false);
}

